const _compareByLabel = (a, b) => {
  if (a.value < b.value) {
    return -1;
  } else if (a.value > b.value) {
    return 1;
  } else {
    return 0;
  }
};

/** Sorts select options by label and optionally orders some options at top.
 *  @param options Array of select options following format used by react-select component. For more
 *                 info on that see https://github.com/JedWatson/react-select/blob/master/README.md
 *  @param initialOptionValues  Array of elements corresponding to .value members of options array that
 *                 indicates options that should appear at top of list instead of being sorted.
 *  @param ignoreMissingOptionValues If true, will quietly ignore any specified option values that
 *                 aren't found within options. Otherwise, will throw an exception.
 *
 *  @return Sorted options.
 */
export const sortSelectOptionsByLabel = ({options, initialOptionValues = [], ignoreMissingOptionValues}) => {

  // Get initial options.
  const initialOptions = [];
  initialOptionValues.forEach( optionValue => {
    const initialOption = options.find(option => option.id === optionValue);
    if (initialOption) {
      initialOptions.push(initialOption);
    } else if (!ignoreMissingOptionValues) {
      throw new Error('Missing option value ' + optionValue);
    }
  });

  // Sort the other options.
  const sortedOptions = options.filter(option => !initialOptionValues.includes(option.id)).sort(_compareByLabel);

  // Return combined options.
  return initialOptions.concat(sortedOptions);
};

export const unitTestPrivate = {
  _compareByLabel
};
